import CommonScreen from './CommonScreen'
export default CommonScreen
